import {
  convertApiMessagesToChatMessages,
  formatMessageText,
  generateUserMessageId,
} from "../utils/messageUtils";

export const syncHistoryMessages = ({
  queryData,
  currentSession,
  shouldRefetchMessages,
  clearMessages,
  addMessage,
  messages,
  syncUnreadFromHistory,
  isOpen,
  setShouldRefetchMessages,
}) => {
  if (!queryData?.messages || !currentSession) {
    return;
  }

  const messagesToProcess =
    queryData.messages.length > 0
      ? queryData.messages.slice(1)
      : queryData.messages || [];

  const oldMessages = convertApiMessagesToChatMessages(
    messagesToProcess,
    currentSession.session_id
  );

  if (shouldRefetchMessages) {
    clearMessages();
    requestAnimationFrame(() => {
      oldMessages.forEach((message) => {
        addMessage(message);
      });
    });
  } else {
    oldMessages.forEach((message) => {
      const messageExists = messages.some((existingMessage) => {
        if (existingMessage.id === message.id) {
          return true;
        }

        if (
          existingMessage.message === message.message &&
          existingMessage.sender === message.sender &&
          existingMessage.sessionId === message.sessionId
        ) {
          const timeDiff = Math.abs(
            new Date(existingMessage.timestamp).getTime() -
              new Date(message.timestamp).getTime()
          );

          return timeDiff < 2000;
        }

        return false;
      });

      if (!messageExists) {
        addMessage(message);
      }
    });
  }

  syncUnreadFromHistory(oldMessages, currentSession.session_id, isOpen);
  setShouldRefetchMessages(false);
};

export const sendChatMessage = async ({
  currentSession,
  isSubmittingMessage,
  setIsSubmittingMessage,
  data,
  addMessage,
  sendMessageMutation,
  messages,
  messageMethods,
}) => {
  if (!currentSession || isSubmittingMessage) {
    return;
  }

  setIsSubmittingMessage(true);

  try {
    const messageId = generateUserMessageId(currentSession.session_id);
    const userMessage = {
      id: messageId,
      sessionId: currentSession.session_id,
      message: formatMessageText(data.message),
      sender: "user",
      timestamp: new Date().toISOString(),
      isRead: true,
    };

    addMessage(userMessage);

    const response = await sendMessageMutation.mutateAsync({
      sessionId: currentSession.session_id,
      messageData: data,
    });

    if (response.success && response.data?.supportResponse) {
      const supportMessage = response.data.supportResponse;
      const messageExists = messages.some(
        (message) =>
          message.id === supportMessage.id ||
          (message.message === supportMessage.message &&
            message.sender === supportMessage.sender &&
            Math.abs(
              new Date(message.timestamp).getTime() -
                new Date(supportMessage.timestamp).getTime()
            ) < 1000)
      );

      if (!messageExists) {
        addMessage(supportMessage);
      }
    }

    messageMethods.reset();
  } finally {
    setIsSubmittingMessage(false);
  }
};
